import React, { FC } from "react";
import { observer } from "mobx-react";
import { DonationGrid, DonorsGrid } from "../../../shared/components";
import { ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
};

const DonationGirdsMain: FC<IProps> = ({ itemStore, merchantAccountStore }) => {
  return (
    <>
      {!itemStore.isDonorGirdActive && (
        <DonationGrid
          itemStore={itemStore}
          merchantAccountStore={merchantAccountStore}
        />
      )}
      {itemStore.isDonorGirdActive && (
        <DonorsGrid
          itemStore={itemStore}
          merchantAccountStore={merchantAccountStore}
        />
      )}
    </>
  );
};

export default observer(DonationGirdsMain);
